// Inside Header.jsx, replace the existing Quick Payment modal section with this:

import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useHistory } from "react-router-dom";
import {
  SITENAME,
  SITENAMEALIAS,
  BASEURL,
  DEMOBROKER,
  CURRENCIES,
  WEBSERVICE,
} from "../utils/init";
import { Helmet } from "react-helmet";
import ProductTour from "./ProductTour";

import { IdleTimerProvider, IdleTimerConsumer } from "react-idle-timer";
import {
  getBrokerDetails,
  getBrokerDetailsByBrokerId,
  GetProfilePicture,
  CreateQuickPaymentProduct,
  SavePaymentLink,
  GetTestUserToken,
  getAuthToken,
  getAuthUuid,
  GetAllInstalledApps,
} from "../utils/service";
import { updateFavicon } from "../utils/favicon";
import { showHttpError, showToast } from "../utils/library";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assets/images/paybitologo.png";
import Cookies from "js-cookie";
import Loader from "./Loader";
const axios = require("axios");

/* ---------------- Child Component ---------------- */
export const Child = () => {
  return (
    <IdleTimerConsumer>
      {(idleTimer) => <h1>{idleTimer.isIdle()}</h1>}
    </IdleTimerConsumer>
  );
};

/* ---------------- Header Component ---------------- */
const Header = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isTestMode } = useSelector((state) => state);
  const [theme, setTheme] = useState(
    localStorage.getItem(SITENAMEALIAS + "_theme") || "dark"
  );
  const [exchangeName, setExchangeName] = useState(
    localStorage.getItem(SITENAMEALIAS + "_exchange") || ""
  );
  const [exchangeLogo, setExchangeLogo] = useState(
    localStorage.getItem(SITENAMEALIAS + "_exchangeLogo") || ""
  );
  const [showCreateMenu, setShowCreateMenu] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showTour, setShowTour] = useState(false);
  const [walletLoading, setWalletLoading] = useState(false);
  const [showQuickPayment, setShowQuickPayment] = useState(false);
  const [quickPayAmount, setQuickPayAmount] = useState("");
  const [quickPayCurrency, setQuickPayCurrency] = useState("USD");
  const [quickPayLoading, setQuickPayLoading] = useState(false);
  const [quickPaySuccess, setQuickPaySuccess] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [generatedPaymentId, setGeneratedPaymentId] = useState("");
  const [modeLoading, setModeLoading] = useState(false);
  const createMenuRef = useRef(null);
  const profileMenuRef = useRef(null);
  const appsMenuRef = useRef(null);
  const [showAppsMenu, setShowAppsMenu] = useState(false);
  const [installedApps, setInstalledApps] = useState([]);
  const [appsLoading, setAppsLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isFooterExpanded, setIsFooterExpanded] = useState(false);
  const [isColorsLoaded, setIsColorsLoaded] = useState(false);

  // Auto-start tour after basic verification is completed
  useEffect(() => {
    const checkAndStartTour = () => {
      const email = localStorage.getItem(SITENAMEALIAS + "_email") || "";
      const tourKey = SITENAMEALIAS + "_product_tour_completed_" + email;
      const tourCompleted = localStorage.getItem(tourKey);
      const isVerified = localStorage.getItem(
        SITENAMEALIAS + "_basic_verification_submitted"
      );
      if (!tourCompleted && isVerified === "1") {
        setTimeout(() => {
          setShowTour(true);
        }, 800);
      }
    };

    checkAndStartTour();

    // Also check on route changes (e.g., after basic verification redirect)
    const unlisten = history.listen(() => {
      checkAndStartTour();
    });

    // Listen for tour restart from header icon
    const handleTourRestart = () => {
      setShowTour(true);
    };
    // Listen for quick payment modal open from other components
    const handleOpenQuickPayment = () => {
      setShowQuickPayment(true);
      setQuickPayAmount("");
      setQuickPayCurrency("USD");
      setQuickPaySuccess(false);
      setGeneratedLink("");
      setGeneratedPaymentId("");
    };
    window.addEventListener("startProductTour", handleTourRestart);
    window.addEventListener("openQuickPayment", handleOpenQuickPayment);

    // Synchronize logo changes in real-time
    const handleLogoUpdate = (e) => {
      if (e.detail) {
        setExchangeLogo(e.detail);
      }
    };
    window.addEventListener("EXCHANGE_LOGO_UPDATED", handleLogoUpdate);

    return () => {
      unlisten();
      window.removeEventListener("startProductTour", handleTourRestart);
      window.removeEventListener("openQuickPayment", handleOpenQuickPayment);
      window.removeEventListener("EXCHANGE_LOGO_UPDATED", handleLogoUpdate);
    };
  }, [history]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (createMenuRef.current && !createMenuRef.current.contains(e.target)) {
        setShowCreateMenu(false);
      }
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(e.target)
      ) {
        setShowProfileMenu(false);
      }
      if (
        appsMenuRef.current &&
        !appsMenuRef.current.contains(e.target)
      ) {
        setShowAppsMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (showAppsMenu) {
      const fetchApps = async () => {
        const uuid =
          localStorage.getItem(SITENAMEALIAS + "_merchant_uuid") ||
          localStorage.getItem("bill_bitcoins_merchant_uuid") ||
          getAuthUuid();
        if (!uuid) return;
        setAppsLoading(true);
        try {
          const res = await GetAllInstalledApps(uuid);
          if (res.data && res.data.appLists) {
            setInstalledApps(res.data.appLists);
          } else {
            setInstalledApps([]);
          }
        } catch (err) {
          console.error("Error fetching installed apps:", err);
          setInstalledApps([]);
        } finally {
          setAppsLoading(false);
        }
      };
      fetchApps();
    }
  }, [showAppsMenu]);

  console.log("Ftheme", theme);

  const handleThemeToggle = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem(SITENAMEALIAS + "_theme", newTheme);
    document.body.setAttribute("data-theme", newTheme);
    window.location.reload();
  };

  const handleToggleMode = async () => {
    if (modeLoading) return;

    if (!isTestMode) {
      // Check for basic verification before allowing switch to Test Mode
      const isVerified = localStorage.getItem(
        SITENAMEALIAS + "_basic_verification_submitted"
      );
      if (isVerified !== "1") {
        showToast("warning", "Please submit basic verification first");
        return;
      }

      setModeLoading(true);
      // Switch to Test Mode
      try {
        const payload = {
          merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          uuid: getAuthUuid(),
        };
        const res = await GetTestUserToken(payload);
        if (res.data && res.data.status) {
          const { stageUuid, authTokenResponse } = res.data.data;
          const { accessToken } = authTokenResponse;

          localStorage.setItem(
            SITENAMEALIAS + "_test_access_token",
            accessToken
          );
          localStorage.setItem(SITENAMEALIAS + "_test_uuid", stageUuid);
          localStorage.setItem(SITENAMEALIAS + "_is_test_mode", "true");
          showToast("success", "Switched to Test Mode");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          showToast("error", "Failed to get test token");
          setModeLoading(false);
        }
      } catch (err) {
        console.error("Error switching to test mode:", err);
        showToast("error", "Failed to switch to test mode");
        setModeLoading(false);
      }
    } else {
      // Switch to Live Mode
      localStorage.setItem(SITENAMEALIAS + "_is_test_mode", "false");
      showToast("success", "Switched to Live Mode");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  console.log("Header rendered with theme:", theme);

  /* -------- Logout -------- */
  const handleLogout = useCallback(async () => {
    // Call logout API using paybito launch platform cookie token

    try {
      const userName = Cookies.get("paybito_launch_platform_user_name");
      const cookieToken = Cookies.get("paybito_launch_platform_token");

      if (userName && cookieToken) {
        const payload = { user_name: userName };
        const response = await fetch(
          "https://institutional-bo.paybito.com:8443/BrokerAdminApi/adminAccess/LogoutAdmin",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `bearer ${cookieToken}`,
            },
            body: JSON.stringify(payload),
          }
        );
        const data = await response.json();
        console.log("Logout data", data);
        // Clear paybito launch platform cookies
        const cookieDomain = ".paybito.com";
        Cookies.remove("paybito_launch_platform_token", {
          domain: cookieDomain,
        });
        Cookies.remove("paybito_launch_platform_broker_id", {
          domain: cookieDomain,
        });
        Cookies.remove("paybito_launch_platform_uuid", {
          domain: cookieDomain,
        });
        Cookies.remove("paybito_launch_platform_user_name", {
          domain: cookieDomain,
        });
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }

    // Clear localStorage
    localStorage.removeItem(SITENAMEALIAS + "_merchant_id");
    localStorage.removeItem(SITENAMEALIAS + "_first_name");
    localStorage.removeItem(SITENAMEALIAS + "_last_name");
    localStorage.removeItem(SITENAMEALIAS + "_email");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_userid");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_id");
    localStorage.removeItem(SITENAMEALIAS + "_access_token");
    localStorage.removeItem(SITENAMEALIAS + "_uuid");
    localStorage.removeItem(SITENAMEALIAS + "_theme");
    localStorage.removeItem(SITENAMEALIAS + "_redirect_path");
    localStorage.removeItem(SITENAMEALIAS + "_is_test_mode");

    history.push("/");
    window.location.reload();
  }, [history]);

  /* -------- Idle Event -------- */
  const onIdle = useCallback(() => {
    console.log("logout");
    handleLogout();
  }, [handleLogout]);
  useEffect(() => {
    // fetchLatestBrokerDetailsByDomain();
    fetchBrokerDetailsByBrokerId();
    fetchProfilePicture();

    const handleProfilePictureUpdate = (e) => {
      if (e.detail?.imageUrl) {
        setProfileImage(e.detail.imageUrl);
      }
    };
    window.addEventListener(
      "profilePictureUpdated",
      handleProfilePictureUpdate
    );
    return () =>
      window.removeEventListener(
        "profilePictureUpdated",
        handleProfilePictureUpdate
      );
  }, []);

  const fetchProfilePicture = () => {
    const uuid = getAuthUuid();
    if (!uuid) return;

    GetProfilePicture(uuid)
      .then((res) => {
        if (res.data && res.data.size > 0) {
          const imageUrl = URL.createObjectURL(res.data);
          setProfileImage(imageUrl);
        }
      })
      .catch(() => {});
  };

  // Fetch latest broker info via domain (always, regardless of login)
  // and sync into state + localStorage so the header reflects the latest values.
  const fetchLatestBrokerDetailsByDomain = useCallback(() => {
    fetchBrokerDetailsByBrokerId();
  }, []);

  const fetchBrokerDetailsByBrokerId = () => {
    const brokerId = localStorage.getItem(SITENAMEALIAS + "_brokerId") || "ATHA24102025105924";
    localStorage.setItem(SITENAMEALIAS + "_brokerId", brokerId);
    localStorage.setItem(SITENAMEALIAS + "_broker_id", brokerId);
    const token = getAuthToken();
    const themeColor = localStorage.getItem(SITENAMEALIAS + "_theme") || "dark";
    if (token) {
      getBrokerDetailsByBrokerId(brokerId)
        .then((res) => {
          console.log("Broker details response:", res.data);

          // Sync latest exchange/logo/company from API response
          const info = res.data?.value?.[0];
          if (info) {
            if (info.exchange) {
              localStorage.setItem(SITENAMEALIAS + "_exchange", info.exchange);
              setExchangeName(info.exchange);
            }
            if (info.exchange_logo) {
              localStorage.setItem(
                SITENAMEALIAS + "_exchangeLogo",
                info.exchange_logo
              );
              setExchangeLogo(info.exchange_logo);
              updateFavicon(info.exchange_logo);
            }
            if (info.company_name) {
              localStorage.setItem(
                SITENAMEALIAS + "_companyName",
                info.company_name
              );
            }
          }

          const body = document.body;
          const allColors = res.data.color;
          let bodyColor, navbarColor;

          if (themeColor === "dark") {
            bodyColor = allColors.darkBackgroundColor || "#000";
            navbarColor = allColors.darkNavbarColor || "rgb(16, 42, 179)";

            body.style.setProperty(
              "--btn-color",
              allColors.internalButtonColor
            );
            body.style.setProperty(
              "--button-active",
              allColors.internalButtonColor
            );
            body.style.setProperty("--font-size", allColors.fontSize);
            body.style.setProperty("--font-family", allColors.font);
            body.style.setProperty("--font-weight", allColors.fontStyle);
            body.style.setProperty(
              "--popupheader-color",
              allColors.popupHeaderColor
            );
            body.style.setProperty(
              "--popupbody-color",
              allColors.popupBodyColor
            );
            body.style.setProperty(
              "--tableheader-color",
              allColors.tableHeaderColor
            );
            body.style.setProperty(
              "--tablebody-color",
              allColors.tableBodyColor
            );
            body.style.setProperty("--text-color", allColors.fontColor);
            body.style.setProperty("--body-color", bodyColor);
            body.style.setProperty("--navbar-color", navbarColor);
            body.style.setProperty(
              "--body-color-less",
              `color-mix(in srgb, ${bodyColor}, white 5%)`
            );
            body.style.setProperty(
              "--body-color-less2",
              `color-mix(in srgb, ${bodyColor}, white 15%)`
            );
            body.style.setProperty(
              "--body-color-less3",
              `color-mix(in srgb, ${bodyColor}, white 20%)`
            );
            body.style.setProperty(
              "--navbar-color-less",
              `color-mix(in srgb, ${navbarColor}, white 5%)`
            );
            body.style.setProperty(
              "--navbar-color-less2",
              `color-mix(in srgb, ${navbarColor}, white 10%)`
            );
            body.style.setProperty(
              "--popup-body-less",
              `color-mix(in srgb, ${allColors.lightPopupBodyColor}, white 5%)`
            );
            body.style.setProperty("--font-style", allColors.fontStyle);
          } else {
            bodyColor = allColors.lightBackgroundColor || "#fff";
            navbarColor = allColors.lightNavbarColor || "rgb(16, 42, 179)";

            body.style.setProperty(
              "--btn-color",
              allColors.lightInternalButtonColor
            );
            body.style.setProperty(
              "--button-active",
              allColors.lightInternalButtonColor
            );
            body.style.setProperty("--font-size", allColors.lightFontSize);
            body.style.setProperty("--font-family", allColors.lightFont);
            body.style.setProperty("--font-weight", allColors.lightFontStyle);
            body.style.setProperty(
              "--popupheader-color",
              allColors.lightPopupHeaderColor
            );
            body.style.setProperty(
              "--popupbody-color",
              allColors.lightPopupBodyColor
            );
            body.style.setProperty(
              "--tableheader-color",
              allColors.lightTableHeaderColor
            );
            body.style.setProperty(
              "--tablebody-color",
              allColors.lightTableBodyColor
            );
            body.style.setProperty("--text-color", allColors.lightFontColor);
            body.style.setProperty("--body-color", bodyColor);
            body.style.setProperty("--navbar-color", navbarColor);
            body.style.setProperty(
              "--body-color-less",
              `color-mix(in srgb, ${bodyColor}, black 5%)`
            );
            body.style.setProperty(
              "--body-color-less2",
              `color-mix(in srgb, ${bodyColor}, black 15%)`
            );
            body.style.setProperty(
              "--body-color-less3",
              `color-mix(in srgb, ${bodyColor}, black 20%)`
            );
            body.style.setProperty(
              "--navbar-color-less",
              `color-mix(in srgb, ${navbarColor}, black 5%)`
            );
            body.style.setProperty(
              "--navbar-color-less2",
              `color-mix(in srgb, ${navbarColor}, black 10%)`
            );
            body.style.setProperty(
              "--popup-body-less",
              `color-mix(in srgb, ${allColors.lightPopupBodyColor}, black 5%)`
            );
            body.style.setProperty("--font-style", allColors.lightFontStyle);
          }

          // Note: dispatch function would need to be passed as prop or from context
          dispatch({ type: "ALL_COLORS", payload: res.data.color });

          console.log("Broker configuration loaded successfully");
          setIsColorsLoaded(true);
        })
        .catch((err) => {
          console.error("Error fetching broker details by ID:", err);
          showToast("error", "Unable to load broker configuration");
          setIsColorsLoaded(true);
        });
    } else {
      setIsColorsLoaded(true);
    }
  };

  const redirectToExchange = async () => {
    if (walletLoading) return;
    setWalletLoading(true);

    try {
      const payload = {
        merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
        brokerId: localStorage.getItem(SITENAMEALIAS + "_brokerId"),
        uuid: getAuthUuid(),
      };
      fetch(`${WEBSERVICE}/merchant/auto-login/exchange`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((data) => {
          // this.setState({ showLoader: false });
          const error = data.error;
          if (error.error_data != "0") {
            showToast("error", error.error_message);
            return;
          }
          const token = data.token;
          const uuid = data.uuid;
          const userId = data.userId;
          localStorage.setItem("paybito_access_token", token);

          const Options = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + token,
            },
            body: JSON.stringify({
              uuid: uuid,
              userId: userId,
            }),
          };

          fetch("https://accounts.paybito.com/api/user/GetUserDetails", Options)
            .then((response) => response.json())
            .then((data) => {
              let paybitouserDetails = data.userResult;
              console.log("paybitouserDetails", paybitouserDetails);
              localStorage.setItem(
                SITENAMEALIAS + "_paybito_id",
                paybitouserDetails.userId
              );
              localStorage.setItem(
                SITENAMEALIAS + "_paybito_uuid",
                paybitouserDetails.uuid
              );

              showToast(
                "success",
                "We are initializing the session with exchange, please wait for few seconds and do not refresh or close the page."
              );

              // const baseUrl = "https://trade.paybito.com/autologin";
              const baseUrl = `${window.location.origin}/autologin`;
              const params = new URLSearchParams({
                brokerId: paybitouserDetails?.brokerId,
                uuid: paybitouserDetails?.uuid, // Use UUID from response
                email: paybitouserDetails?.email,
                token: token, // Add token from response
                callFrom: "payments",
              });

              const redirectUrl = `${baseUrl}?${params.toString()}`;

              window.open(redirectUrl, "_blank");
              setWalletLoading(false);
            })
            .catch(() => {
              setWalletLoading(false);
            });
        })
        .catch((error) => {
          setWalletLoading(false);
          showToast("error", "Failed to initialize session with exchange.");
        });
    } catch (error) {
      setWalletLoading(false);
      showHttpError(error);
    }
  };

  /* Placeholder callbacks (same as class version props references) */
  const onPrompt = () => {};
  const onActive = () => {};
  const onAction = () => {};

  const isPermissionLevel2 = (() => {
    const accountStatusId = localStorage.getItem(
      SITENAMEALIAS + "_account_status_id"
    );
    if (accountStatusId == "6") {
      if (localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0") {
        const access = JSON.parse(
          localStorage.getItem(SITENAMEALIAS + "_access_list")
        );
        return access && access.length > 0;
      }
      return true;
    }
    return false;
  })();

  // For sub-merchants, returns true if their access_list grants WRITE on the given URL.
  // Parent merchants always have write access.
  const hasWriteAccessFor = (url) => {
    const isSubMerchant =
      localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0";
    if (!isSubMerchant) return true;
    try {
      const access = JSON.parse(
        localStorage.getItem(SITENAMEALIAS + "_access_list")
      );
      if (!access) return false;
      const entry = access.find(
        (a) => a.url && a.url.toLowerCase() === url.toLowerCase()
      );
      return entry ? entry.access === "WRITE" : false;
    } catch {
      return false;
    }
  };
  const canCreatePayment = hasWriteAccessFor("create-payment");

  const hasMenuPermission = (permissionTitle) => {
    const isSubMerchant =
      localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0";
    if (isSubMerchant) {
      // Sub-merchants: gate strictly by access_list, regardless of verification status
      const access = JSON.parse(
        localStorage.getItem(SITENAMEALIAS + "_access_list")
      );
      if (access) {
        return access.some(
          (a) =>
            a.menu && a.menu.toLowerCase() === permissionTitle.toLowerCase()
        );
      }
      return false;
    }
    // Parent merchant: only after verification
    const accountStatusId = localStorage.getItem(
      SITENAMEALIAS + "_account_status_id"
    );
    return accountStatusId == "6";
  };

  const content = localStorage.getItem(SITENAMEALIAS + "_paybito_id") ? (
    <h6 style={{ marginTop: "11px", color: "white" }}>
      Logged into{" "}
      {exchangeName || localStorage.getItem(SITENAMEALIAS + "_exchange")}
    </h6>
  ) : null;

  // Quick Payment Handler - Create product and payment link directly using returned priceId
  const handleQuickPayment = async () => {
    const amount = parseFloat(quickPayAmount);
    if (!quickPayAmount || isNaN(amount) || amount <= 0) {
      showToast("error", "Please enter a valid amount");
      return;
    }

    setQuickPayLoading(true);

    try {
      const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
      const timestamp = Date.now();
      const productId = `QUICK_${timestamp}`;
      const productName = `Quick Payment ${new Date().toLocaleString()}`;

      // Step 1: Create a product with the price included
      const productPayload = {
        merchantId: parseInt(merchantId),
        products: [
          {
            productId: productId,
            productType: "QUICK_PAYMENT",
            name: productName,
            description: "Quick payment product",
            imageUrl: "",
            attributes: {},
            metadata: {
              type: "quick_payment",
              created_at: new Date().toISOString(),
            },
            prices: [
              {
                isDefault: true,
                priceType: "one-time",
                intervalType: null,
                intervalCount: null,
                trialDays: 0,
                variant: {},
                sku: "",
                inventory: {
                  track: false,
                  quantity: 0,
                },
                currencies: [
                  {
                    currency: quickPayCurrency,
                    amount: amount,
                    isDefault: true,
                  },
                ],
              },
            ],
          },
        ],
      };

      const productResponse = await CreateQuickPaymentProduct(productPayload);

      console.log("Product creation response:", productResponse.data);

      // Check if product was created successfully
      if (!productResponse.data.status) {
        throw new Error(
          productResponse.data.message || "Failed to create product"
        );
      }

      // Extract productId and priceId directly from response
      const createdProduct = productResponse.data.data?.products?.[0];
      const createdProductId = createdProduct?.productId;
      const createdPriceId = createdProduct?.priceStatuses?.[0]?.priceId;

      if (!createdProductId) {
        throw new Error("Product ID not returned from product creation");
      }

      if (!createdPriceId) {
        throw new Error("Price ID not returned from product creation");
      }

      console.log(
        `Created product ID: ${createdProductId}, Price ID: ${createdPriceId}`
      );

      // Step 2: Create payment link directly using the returned price ID
      const paymentPayload = {
        merchantId: parseInt(merchantId),
        paymentName: productName,
        paymentType: "CHECKOUT",
        productId: createdProductId,
        priceId: createdPriceId,
        shippingProfileId: 0,
        buyerProfileId: 0,
        discountProfileName: "",
        billingId: 0,
        isProcessingFeeApplied: 0,
        redirectId: 0,
      };

      console.log("Payment payload:", paymentPayload);

      const paymentResponse = await axios.post(
        `${WEBSERVICE}/payment/create`,
        JSON.stringify(paymentPayload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      );

      console.log("Payment response:", paymentResponse.data);

      if (paymentResponse.data.error !== "0") {
        throw new Error(
          paymentResponse.data.message || "Failed to create payment link"
        );
      }

      const paymentId = paymentResponse.data.id;

      const baseUrl = `${window.location.origin}/merchant/checkout`;
      const paymentLink = `${baseUrl}/${encodeURIComponent(String(paymentId))}`;

      setGeneratedLink(paymentLink);
      setGeneratedPaymentId(paymentId);
      setQuickPaySuccess(true);
      showToast("success", "Payment link created successfully!");
    } catch (error) {
      console.error("Quick payment error:", error);
      showToast(
        "error",
        error.message || "Failed to create payment link. Please try again."
      );
    } finally {
      setQuickPayLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        showToast("success", "Copied to clipboard!");
      })
      .catch(() => {
        showToast("error", "Failed to copy");
      });
  };

  const resetModalAndClose = () => {
    setShowQuickPayment(false);
    setQuickPayAmount("");
    setQuickPayCurrency("USD");
    setQuickPaySuccess(false);
    setGeneratedLink("");
    setGeneratedPaymentId("");
    setCopied(false);
  };

  const openPaymentLink = () => {
    if (generatedLink) {
      window.open(generatedLink, "_blank");
    }
  };

  useEffect(() => {
    updateFavicon(exchangeLogo);
  }, [exchangeLogo]);

  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {exchangeName || localStorage.getItem(SITENAMEALIAS + "_exchange")}
        </title>
      </Helmet>

      {/* <IdleTimerProvider
        timeout={1000 * 3600}
        onPrompt={onPrompt}
        onIdle={onIdle}
        onActive={onActive}
        onAction={onAction}
      >
        <Child />
      </IdleTimerProvider> */}

      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div
          className="navbar-menu-wrapper d-flex align-items-stretch"
          style={{
            background: "var(--navbar-color)",
          }}
        >
          <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
            {/* brand-logo-mini */}
            <a className="navbar-brand" href={BASEURL}>
              <div className="image-container">
                <img
                  src={
                    exchangeLogo ||
                    localStorage.getItem(SITENAMEALIAS + "_exchangeLogo")
                  }
                  className="logo-cred "
                  alt={exchangeName || "logo"}
                />
              </div>
            </a>
          </div>

          <ul className="navbar-nav"></ul>

          <ul
            className="navbar-nav navbar-nav-right"
            style={{ gap: "12px", alignItems: "center" }}
          >
            {/* Mobile Hamburger Menu - Positioned Left via CSS */}
            {getAuthToken() && (
              <li
                className="nav-item mobile-hamburger-menu d-flex d-lg-none"
                style={{
                  display: "flex !important",
                  alignItems: "center",
                  padding: "0 4px",
                  margin: 0,
                  position: "absolute",
                  left: "4px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                <button
                  className="btn btn-sm"
                  onClick={() => {
                    console.log(
                      "Hamburger clicked - dispatching TOGGLE_SIDEBAR"
                    );
                    dispatch({ type: "TOGGLE_SIDEBAR" });
                  }}
                  style={{
                    background: "transparent",
                    color: "var(--text-color)",
                    border: "none",
                    fontSize: "22px",
                    padding: "6px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "44px",
                    height: "44px",
                    borderRadius: "8px",
                    transition: "background 0.2s, transform 0.15s",
                    zIndex: 100,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(128,128,128,0.1)";
                    e.currentTarget.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                  onTouchStart={(e) => {
                    e.currentTarget.style.background = "rgba(128,128,128,0.15)";
                  }}
                  onTouchEnd={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                  title="Toggle menu"
                >
                  <i className="mdi mdi-menu" style={{ fontSize: "22px" }}></i>
                </button>
              </li>
            )}

            {getAuthToken() && hasMenuPermission("Create Payment") && (
              <li
                className="nav-item d-none d-lg-flex"
                ref={createMenuRef}
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  padding: 0,
                  margin: 0,
                }}
                data-tour="create-button"
              >
                <button
                  className="btn btn-sm d-flex align-items-center"
                  onClick={() => setShowCreateMenu(!showCreateMenu)}
                  title={
                    !isPermissionLevel2
                      ? "Complete business verification to start accepting payments"
                      : undefined
                  }
                  style={{
                    background:
                      "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    color: "#fff",
                    border: "1px solid rgba(255,255,255,0.15)",
                    borderRadius: "10px",
                    padding: "7px 18px",
                    fontSize: "13px",
                    fontWeight: "600",
                    gap: "6px",
                    cursor: "pointer",
                    letterSpacing: "0.3px",
                    boxShadow: "0 2px 8px rgba(99,102,241,0.35)",
                    transition: "all 0.2s ease",
                    opacity: !isPermissionLevel2 ? 0.65 : 1,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 4px 14px rgba(99,102,241,0.5)";
                    e.currentTarget.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(99,102,241,0.35)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                  Create
                  {!isPermissionLevel2 && (
                    <span style={{ fontSize: "12px", marginLeft: "2px" }}>
                      🔒
                    </span>
                  )}
                </button>
                {showCreateMenu && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      marginTop: "6px",
                      background: "var(--popupbody-color, #1e1e2d)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      borderRadius: "12px",
                      boxShadow: "0 12px 32px rgba(0,0,0,0.35)",
                      minWidth: "280px",
                      zIndex: 1000,
                      overflow: "hidden",
                      padding: "6px",
                    }}
                  >
                    {/* Create Payment Link */}
                    <div
                      onClick={
                        !isPermissionLevel2 || !canCreatePayment
                          ? () => {
                              if (!canCreatePayment && isPermissionLevel2) {
                                showToast(
                                  "error",
                                  "You need write access to perform this operation"
                                );
                              }
                            }
                          : () => {
                              setShowCreateMenu(false);
                              history.push("/create-payment");
                            }
                      }
                      title={
                        !isPermissionLevel2
                          ? "Complete business verification to start accepting payments"
                          : !canCreatePayment
                          ? "You need write access to perform this operation"
                          : undefined
                      }
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        padding: "14px 14px",
                        cursor:
                          !isPermissionLevel2 || !canCreatePayment
                            ? "not-allowed"
                            : "pointer",
                        borderRadius: "8px",
                        transition: "background 0.2s",
                        opacity:
                          !isPermissionLevel2 || !canCreatePayment ? 0.5 : 1,
                      }}
                      onMouseEnter={
                        !isPermissionLevel2 || !canCreatePayment
                          ? undefined
                          : (e) =>
                              (e.currentTarget.style.background =
                                "rgba(255,255,255,0.08)")
                      }
                      onMouseLeave={
                        !isPermissionLevel2 || !canCreatePayment
                          ? undefined
                          : (e) =>
                              (e.currentTarget.style.background = "transparent")
                      }
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "10px",
                          background: "rgba(99,102,241,0.15)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          marginTop: "2px",
                        }}
                      >
                        <i
                          className="mdi mdi-link-variant"
                          style={{
                            fontSize: "18px",
                            color: "#8b5cf6",
                          }}
                        ></i>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "3px",
                          }}
                        >
                          <span
                            style={{
                              color: "var(--text-color, #fff)",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            Create Payment
                          </span>
                        </div>
                        {!isPermissionLevel2 ? (
                          <span style={{ fontSize: "13px" }}>🔒</span>
                        ) : (
                          <span
                            style={{
                              background:
                                "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)",
                              color: "#fff",
                              fontSize: "10px",
                              fontWeight: "700",
                              padding: "2px 7px",
                              borderRadius: "4px",
                              letterSpacing: "0.3px",
                              lineHeight: "16px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Recommended
                          </span>
                        )}{" "}
                        <br></br>
                        <span
                          style={{
                            color: "var(--text-color, #fff)",
                            opacity: 0.45,
                            fontSize: "12px",
                          }}
                        >
                          Use a product or plan
                        </span>
                      </div>
                    </div>

                    {/* Divider */}
                    <div
                      style={{
                        height: "1px",
                        background: "rgba(255,255,255,0.08)",
                        margin: "2px 8px",
                      }}
                    ></div>

                    {/* Quick Payment */}
                    <div
                      onClick={
                        !isPermissionLevel2 || !canCreatePayment
                          ? () => {
                              if (!canCreatePayment && isPermissionLevel2) {
                                showToast(
                                  "error",
                                  "You need write access to perform this operation"
                                );
                              }
                            }
                          : () => {
                              setShowCreateMenu(false);
                              setShowQuickPayment(true);
                              setQuickPayAmount("");
                              setQuickPayCurrency("USD");
                              setQuickPaySuccess(false);
                              setGeneratedLink("");
                              setGeneratedPaymentId("");
                            }
                      }
                      title={
                        !isPermissionLevel2
                          ? "Complete business verification to start accepting payments"
                          : !canCreatePayment
                          ? "You need write access to perform this operation"
                          : undefined
                      }
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        padding: "14px 14px",
                        cursor:
                          !isPermissionLevel2 || !canCreatePayment
                            ? "not-allowed"
                            : "pointer",
                        borderRadius: "8px",
                        transition: "background 0.2s",
                        opacity:
                          !isPermissionLevel2 || !canCreatePayment ? 0.5 : 1,
                      }}
                      onMouseEnter={
                        !isPermissionLevel2 || !canCreatePayment
                          ? undefined
                          : (e) =>
                              (e.currentTarget.style.background =
                                "rgba(255,255,255,0.08)")
                      }
                      onMouseLeave={
                        !isPermissionLevel2 || !canCreatePayment
                          ? undefined
                          : (e) =>
                              (e.currentTarget.style.background = "transparent")
                      }
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "10px",
                          background: "rgba(34,197,94,0.15)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          marginTop: "2px",
                        }}
                      >
                        <i
                          className="mdi mdi-flash"
                          style={{
                            fontSize: "18px",
                            color: "#22c55e",
                          }}
                        ></i>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "3px",
                          }}
                        >
                          <span
                            style={{
                              color: "var(--text-color, #fff)",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            Quick Payment
                          </span>
                          {!isPermissionLevel2 && (
                            <span style={{ fontSize: "13px" }}>🔒</span>
                          )}
                        </div>
                        <span
                          style={{
                            color: "var(--text-color, #fff)",
                            opacity: 0.45,
                            fontSize: "12px",
                          }}
                        >
                          Enter an amount instantly
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </li>
            )}

            {getAuthToken() &&
              !isTestMode &&
              localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") ==
                "0" &&
              hasMenuPermission("Settlement Wallets") && (
                <li
                  className="nav-item"
                  data-tour="wallet-button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <a
                    href="javascript:void(0)"
                    onClick={walletLoading ? undefined : redirectToExchange}
                    style={{
                      color: "#8e7e7e",
                      fontSize: "14px",
                      cursor: walletLoading ? "not-allowed" : "pointer",
                      textDecoration: "none",
                      opacity: walletLoading ? 0.6 : 1,
                      pointerEvents: walletLoading ? "none" : "auto",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "0 8px",
                    }}
                  >
                    {walletLoading && (
                      <span
                        style={{
                          display: "inline-block",
                          width: "14px",
                          height: "14px",
                          border: "2px solid rgba(142,126,126,0.3)",
                          borderTop: "2px solid #8e7e7e",
                          borderRadius: "50%",
                          animation: "spin 0.8s linear infinite",
                        }}
                      />
                    )}
                    <span
                      style={{ display: "none" }}
                      className="d-none d-lg-inline"
                    >
                      {walletLoading
                        ? "Loading..."
                        : `${
                            exchangeName ||
                            localStorage.getItem(SITENAMEALIAS + "_exchange")
                          } Wallet`}
                    </span>
                    <i
                      className="mdi mdi-wallet-outline d-lg-none"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </a>
                </li>
              )}




            {/* App Grid Icon Button & Popover Drawer - Left of Profile Avatar */}
            {getAuthToken() && (
              <li
                className="nav-item"
                ref={appsMenuRef}
                style={{
                  position: "relative",
                  listStyle: "none",
                  display: "flex",
                  alignItems: "center",
                  padding: 0,
                  margin: 0,
                }}
                data-tour="apps-drawer"
              >
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => setShowAppsMenu(!showAppsMenu)}
                  style={{
                    background: showAppsMenu
                      ? "rgba(255,255,255,0.12)"
                      : "transparent",
                    backgroundColor: showAppsMenu
                      ? "rgba(255,255,255,0.12)"
                      : "transparent",
                    border: "none",
                    borderRadius: "10px",
                    width: "38px",
                    height: "38px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "#ffffff",
                    transition: "all 0.2s ease",
                    padding: 0,
                    outline: "none",
                    boxShadow: "none",
                  }}
                  title="My Apps"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.12)";
                    e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.12)";
                  }}
                  onMouseLeave={(e) => {
                    if (!showAppsMenu) {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="3" width="7" height="7" rx="1.5" />
                    <rect x="14" y="3" width="7" height="7" rx="1.5" />
                    <rect x="14" y="14" width="7" height="7" rx="1.5" />
                    <rect x="3" y="14" width="7" height="7" rx="1.5" />
                  </svg>
                </div>

                {showAppsMenu && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      marginTop: "10px",
                      background: "var(--popupbody-color, #181824)",
                      border: "1px solid rgba(255,255,255,0.12)",
                      borderRadius: "16px",
                      boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
                      width: "420px",
                      maxHeight: "540px",
                      overflowY: "auto",
                      zIndex: 1050,
                      padding: "20px",
                      color: "var(--text-color, #fff)",
                    }}
                  >
                    {/* Section: My Apps */}
                    <div style={{ marginBottom: "12px" }}>
                      <h6
                        style={{
                          margin: 0,
                          color: "var(--text-color, #fff)",
                          fontWeight: 700,
                          fontSize: "15px",
                        }}
                      >
                        My Apps
                      </h6>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "rgba(255,255,255,0.5)",
                        }}
                      >
                        Your installed applications
                      </span>
                    </div>

                    {/* Installed Apps Grid */}
                    {appsLoading ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "24px 0",
                          color: "rgba(255,255,255,0.5)",
                          fontSize: "13px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            width: "16px",
                            height: "16px",
                            border: "2px solid rgba(255,255,255,0.2)",
                            borderTop: "2px solid #fff",
                            borderRadius: "50%",
                            animation: "spin 0.8s linear infinite",
                            marginRight: "8px",
                          }}
                        />
                        Loading installed apps...
                      </div>
                    ) : installedApps.length > 0 ? (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        {installedApps.map((app, idx) => (
                          <div
                            key={app.appId || idx}
                            onClick={() => {
                              if (app.appUrl) {
                                window.open(app.appUrl, "_blank");
                              } else {
                                showToast("warning", "App URL not available");
                              }
                              setShowAppsMenu(false);
                            }}
                            title={`${app.name}${app.description ? "\n\n" + app.description : ""}`}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "14px 8px",
                              borderRadius: "12px",
                              cursor: "pointer",
                              background: "rgba(255,255,255,0.03)",
                              border: "1px solid rgba(255,255,255,0.06)",
                              transition: "all 0.2s ease",
                              minWidth: 0,
                              boxSizing: "border-box",
                              width: "100%",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background =
                                "rgba(255,255,255,0.08)";
                              e.currentTarget.style.borderColor =
                                "rgba(255,255,255,0.15)";
                              e.currentTarget.style.transform =
                                "translateY(-2px)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background =
                                "rgba(255,255,255,0.03)";
                              e.currentTarget.style.borderColor =
                                "rgba(255,255,255,0.06)";
                              e.currentTarget.style.transform = "translateY(0)";
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                background: "rgba(99, 102, 241, 0.15)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "8px",
                                overflow: "hidden",
                                flexShrink: 0,
                              }}
                            >
                              {app.icon ? (
                                <img
                                  src={app.icon}
                                  alt={app.name}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.style.display = "none";
                                    if (e.currentTarget.nextSibling) {
                                      e.currentTarget.nextSibling.style.display =
                                        "flex";
                                    }
                                  }}
                                />
                              ) : null}
                              <div
                                style={{
                                  display: app.icon ? "none" : "flex",
                                  width: "100%",
                                  height: "100%",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#6366f1",
                                  fontWeight: "bold",
                                  fontSize: "15px",
                                }}
                              >
                                {app.name
                                  ? app.name.charAt(0).toUpperCase()
                                  : "$"}
                              </div>
                            </div>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "var(--text-color, #fff)",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "100%",
                                display: "block",
                              }}
                            >
                              {app.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div
                        style={{
                          padding: "20px 12px",
                          color: "rgba(255,255,255,0.7)",
                          fontSize: "13px",
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "12px",
                            background: "rgba(99, 102, 241, 0.12)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="mdi mdi-package-variant-closed"
                            style={{ fontSize: "22px", color: "#6366f1" }}
                          ></i>
                        </div>
                        <div>
                          <div
                            style={{
                              fontWeight: "600",
                              color: "var(--text-color, #fff)",
                              marginBottom: "4px",
                            }}
                          >
                            No installed apps found
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "rgba(255,255,255,0.45)",
                              lineHeight: "1.4",
                            }}
                          >
                            Explore and install apps from the App Store
                          </div>
                        </div>
                        <a
                          href={`${window.location.origin}/app-store`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowAppsMenu(false);
                            window.open(`${window.location.origin}/app-store`, "_blank");
                          }}
                          style={{
                            background:
                              "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                            color: "#ffffff",
                            borderRadius: "8px",
                            padding: "8px 18px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textDecoration: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            boxShadow: "0 2px 8px rgba(99,102,241,0.35)",
                            marginTop: "4px",
                            cursor: "pointer",
                          }}
                        >
                          <i
                            className="mdi mdi-store-outline"
                            style={{ fontSize: "15px" }}
                          ></i>
                          Go to App Store
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </li>
            )}

            {getAuthToken() && (
              <li
                className="nav-item"
                ref={profileMenuRef}
                style={{
                  position: "relative",
                  listStyle: "none",
                  display: "flex",
                  alignItems: "center",
                  padding: 0,
                  margin: 0,
                }}
                data-tour="profile-menu"
              >
                <div
                  onClick={() => setShowProfileMenu(!showProfileMenu)}
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "50%",
                    background: profileImage ? "transparent" : "gray",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "700",
                    textTransform: "uppercase",
                    userSelect: "none",
                    overflow: "hidden",
                    transition: "transform 0.2s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                  title="Profile"
                >
                  {profileImage ? (
                    <img
                      src={profileImage}
                      alt="Profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <>
                      {(
                        localStorage.getItem(SITENAMEALIAS + "_first_name") ||
                        "U"
                      ).charAt(0)}
                      {(
                        localStorage.getItem(SITENAMEALIAS + "_last_name") || ""
                      ).charAt(0)}
                    </>
                  )}
                </div>
                {showProfileMenu && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      marginTop: "6px",
                      background: "var(--popupbody-color, #1e1e2d)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      borderRadius: "8px",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                      minWidth: "200px",
                      zIndex: 1000,
                      overflow: "hidden",
                    }}
                  >
                    {[
                      ...(hasMenuPermission("Profile")
                        ? [
                            {
                              icon: "mdi-account-circle",
                              label: "Profile",
                              path: "/profile",
                            },
                          ]
                        : []),
                      ...(hasMenuPermission("User Settings") && !isTestMode
                        ? [
                            {
                              icon: "mdi-account-settings",
                              label: "User Settings",
                              path: "/user-settings",
                            },
                          ]
                        : []),
                      ...(hasMenuPermission("Business Settings") && !isTestMode
                        ? [
                            {
                              icon: "mdi-office-building",
                              label: "Business Settings",
                              path: "/business-settings",
                            },
                          ]
                        : []),
                    ].map((item) => (
                      <div
                        key={item.path}
                        onClick={() => {
                          setShowProfileMenu(false);
                          history.push(item.path);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "10px 16px",
                          color: "var(--text-color, #fff)",
                          fontSize: "14px",
                          cursor: "pointer",
                          transition: "background 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background =
                            "rgba(255,255,255,0.08)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <i
                          className={`mdi ${item.icon}`}
                          style={{ fontSize: "18px" }}
                        ></i>
                        {item.label}
                      </div>
                    ))}
                    <div
                      onClick={() => {
                        setShowProfileMenu(false);
                        handleThemeToggle();
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "10px 16px",
                        color: "var(--text-color, #fff)",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "background 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background =
                          "rgba(255,255,255,0.08)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      <i
                        className={
                          theme === "dark"
                            ? "mdi mdi-weather-sunny"
                            : "mdi mdi-weather-night"
                        }
                        style={{ fontSize: "18px" }}
                      ></i>
                      Change theme
                    </div>
                    <div
                      style={{
                        borderTop: "1px solid rgba(255,255,255,0.1)",
                      }}
                    >
                      <div
                        onClick={() => {
                          setShowProfileMenu(false);
                          setShowLogoutConfirm(true);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          padding: "10px 16px",
                          color: "var(--text-color, #fff)",
                          fontSize: "14px",
                          cursor: "pointer",
                          transition: "background 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background =
                            "rgba(255,255,255,0.08)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <i
                          className="mdi mdi-logout-variant"
                          style={{ fontSize: "18px" }}
                        ></i>
                        Logout
                      </div>
                    </div>
                  </div>
                )}
              </li>
            )}

            <li
              className="nav-item"
              data-tour="help-icon"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0 6px",
                margin: 0,
              }}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/playlist?list=PLjtm4vdHCgKYSbMHOgK4Y68P1cEv8XPgp"
                title="Help - How this works?"
                style={{
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  fontWeight: "bold",
                  textDecoration: "none",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                ?
              </a>
            </li>

            <li
              className="nav-item"
              data-tour="tour-icon"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0 6px",
                margin: 0,
              }}
            >
              <div
                onClick={() => {
                  window.dispatchEvent(new CustomEvent("startProductTour"));
                }}
                title="Start Product Tour"
                style={{
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "25px",
                  cursor: "pointer",
                  textDecoration: "none",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  transition: "all 0.2s ease",
                  color: "var(--text-color, #fff)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background =
                    "color-mix(in srgb, var(--btn-color, #284ccf), transparent 85%)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                }}
              >
                <i
                  className="mdi mdi-compass-outline"
                  style={{ fontSize: "22px" }}
                ></i>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      {showLogoutConfirm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setShowLogoutConfirm(false)}
        >
          <div
            style={{
              background: "var(--popupbody-color, #1e1e2d)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "12px",
              padding: "28px 32px",
              minWidth: "340px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
              textAlign: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <i
              className="mdi mdi-logout-variant"
              style={{
                fontSize: "32px",
                color: "#ef4444",
                marginBottom: "12px",
                display: "block",
              }}
            ></i>
            <h5
              style={{
                color: "var(--text-color, #fff)",
                fontSize: "17px",
                fontWeight: "700",
                marginBottom: "8px",
              }}
            >
              Are you sure you want to log out?
            </h5>
            <p
              style={{
                color: "var(--text-color, #fff)",
                opacity: 0.5,
                fontSize: "13px",
                marginBottom: "24px",
              }}
            >
              You will need to sign in again to access your account.
            </p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <button
                onClick={() => {
                  setShowLogoutConfirm(false);
                  handleLogout();
                }}
                style={{
                  padding: "9px 24px",
                  background: "#ef4444",
                  color: "#fff",
                  borderRadius: "10px",
                  fontSize: "13px",
                  fontWeight: "600",
                  border: "none",
                  cursor: "pointer",
                  transition: "opacity 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                Log Out
              </button>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                style={{
                  padding: "9px 24px",
                  background: "transparent",
                  color: "var(--text-color, #fff)",
                  borderRadius: "10px",
                  fontSize: "13px",
                  fontWeight: "600",
                  border: "1px solid rgba(255,255,255,0.15)",
                  cursor: "pointer",
                  transition: "opacity 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== Quick Payment Modal ===== */}
      {showQuickPayment && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            backdropFilter: "blur(5px)",
          }}
          onClick={() => !quickPayLoading && resetModalAndClose()}
        >
          <div
            style={{
              background: "var(--popupbody-color, #1e1e2d)",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: "20px",
              padding: quickPaySuccess ? "28px 32px" : "32px",
              width: quickPaySuccess ? "480px" : "440px",
              maxWidth: "90vw",
              boxShadow: "0 24px 64px rgba(0,0,0,0.5)",
              position: "relative",
              transition: "all 0.3s ease",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            {!quickPayLoading && (
              <button
                onClick={resetModalAndClose}
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  background: "rgba(255,255,255,0.08)",
                  border: "none",
                  borderRadius: "8px",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "var(--text-color, #fff)",
                  fontSize: "18px",
                  transition: "background 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.15)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.08)")
                }
              >
                <i className="mdi mdi-close"></i>
              </button>
            )}

            {!quickPaySuccess ? (
              // Input Form State
              <>
                {/* Title */}
                <div style={{ textAlign: "center", marginBottom: "28px" }}>
                  <div
                    style={{
                      width: "56px",
                      height: "56px",
                      background:
                        "linear-gradient(135deg, #22c55e20, #16a34a20)",
                      borderRadius: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <i
                      className="mdi mdi-flash"
                      style={{ fontSize: "28px", color: "#22c55e" }}
                    ></i>
                  </div>
                  <h4
                    style={{
                      color: "var(--text-color, #fff)",
                      fontSize: "22px",
                      fontWeight: "700",
                      marginBottom: "6px",
                    }}
                  >
                    Quick Payment
                  </h4>
                  <p
                    style={{
                      color: "var(--text-color, #fff)",
                      opacity: 0.5,
                      fontSize: "13px",
                      margin: 0,
                    }}
                  >
                    Create a payment link instantly
                  </p>
                </div>

                {/* Amount label */}
                <label
                  style={{
                    display: "block",
                    color: "var(--text-color, #fff)",
                    fontSize: "13px",
                    fontWeight: "600",
                    marginBottom: "8px",
                  }}
                >
                  Amount
                </label>

                {/* Amount input with currency */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "rgba(255,255,255,0.06)",
                    border: "1.5px solid rgba(255,255,255,0.12)",
                    borderRadius: "12px",
                    overflow: "hidden",
                    marginBottom: "24px",
                    transition: "border-color 0.2s",
                  }}
                >
                  {/* Currency selector */}
                  <select
                    value={quickPayCurrency}
                    onChange={(e) => setQuickPayCurrency(e.target.value)}
                    style={{
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      color: "var(--text-color, #fff)",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "14px 4px 14px 14px",
                      cursor: "pointer",
                      appearance: "none",
                      WebkitAppearance: "none",
                      width: "70px",
                      flexShrink: 0,
                    }}
                  >
                    {CURRENCIES.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.flag} {c.code}
                      </option>
                    ))}
                  </select>

                  {/* Divider */}
                  <div
                    style={{
                      width: "1px",
                      height: "28px",
                      background: "rgba(255,255,255,0.15)",
                      flexShrink: 0,
                    }}
                  ></div>

                  {/* Amount input */}
                  <input
                    type="number"
                    placeholder="0.00"
                    value={quickPayAmount}
                    onChange={(e) => setQuickPayAmount(e.target.value)}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        quickPayAmount &&
                        !quickPayLoading
                      ) {
                        handleQuickPayment();
                      }
                    }}
                    autoFocus
                    style={{
                      flex: 1,
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      color: "var(--text-color, #fff)",
                      fontSize: "16px",
                      fontWeight: "500",
                      padding: "14px 14px",
                      width: "100%",
                    }}
                  />

                  {/* Currency dropdown icon */}
                  <div
                    style={{
                      padding: "0 12px",
                      opacity: 0.4,
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className="mdi mdi-chevron-down"
                      style={{
                        fontSize: "18px",
                        color: "var(--text-color, #fff)",
                      }}
                    ></i>
                  </div>
                </div>

                {/* Create Link button */}
                <button
                  onClick={handleQuickPayment}
                  disabled={quickPayLoading}
                  style={{
                    width: "100%",
                    padding: "14px",
                    background: quickPayLoading
                      ? "rgba(99,102,241,0.5)"
                      : "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "12px",
                    fontSize: "15px",
                    fontWeight: "700",
                    cursor: quickPayLoading ? "not-allowed" : "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 16px rgba(99,102,241,0.4)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                  onMouseEnter={(e) => {
                    if (!quickPayLoading) {
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow =
                        "0 6px 24px rgba(99,102,241,0.5)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!quickPayLoading) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 16px rgba(99,102,241,0.4)";
                    }
                  }}
                >
                  {quickPayLoading ? (
                    <>
                      <i
                        className="mdi mdi-loading mdi-spin"
                        style={{ fontSize: "18px" }}
                      />
                      Creating Payment Link...
                    </>
                  ) : (
                    <>
                      <i
                        className="mdi mdi-magic-staff"
                        style={{ fontSize: "18px" }}
                      />
                      Create Payment
                    </>
                  )}
                </button>
              </>
            ) : (
              // Success State - Show generated link
              <>
                {/* Success Icon */}
                <div style={{ textAlign: "center", marginBottom: "24px" }}>
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      background: "#10b98120",
                      borderRadius: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <i
                      className="mdi mdi-check-circle"
                      style={{ fontSize: "36px", color: "#10b981" }}
                    ></i>
                  </div>
                  <h4
                    style={{
                      color: "var(--text-color, #fff)",
                      fontSize: "20px",
                      fontWeight: "700",
                      marginBottom: "4px",
                    }}
                  >
                    Payment Link Created!
                  </h4>
                  <p
                    style={{
                      color: "var(--text-color, #fff)",
                      opacity: 0.5,
                      fontSize: "12px",
                      margin: 0,
                    }}
                  >
                    ID: {generatedPaymentId}
                  </p>
                </div>

                {/* Link Display */}
                <div
                  style={{
                    background: "rgba(255,255,255,0.05)",
                    borderRadius: "12px",
                    padding: "12px 16px",
                    marginBottom: "20px",
                    border: "1px solid rgba(255,255,255,0.1)",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      flex: 1,
                      fontSize: "12px",
                      fontFamily: "monospace",
                      color: "#818cf8",
                      wordBreak: "break-all",
                    }}
                  >
                    {generatedLink}
                  </span>
                  <button
                    onClick={() => copyToClipboard(generatedLink)}
                    style={{
                      background: "rgba(99,102,241,0.2)",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 14px",
                      color: "#818cf8",
                      fontSize: "12px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        "rgba(99,102,241,0.35)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(99,102,241,0.2)";
                    }}
                  >
                    <i
                      className="mdi mdi-content-copy"
                      style={{ fontSize: "14px" }}
                    />
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </div>

                {/* Action Buttons */}
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <button
                    onClick={openPaymentLink}
                    style={{
                      flex: 1,
                      padding: "12px",
                      background:
                        "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "10px",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      transition: "opacity 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.opacity = "0.9")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    <i
                      className="mdi mdi-open-in-new"
                      style={{ fontSize: "16px" }}
                    />
                    Open Payment Page
                  </button>
                </div>

                <button
                  onClick={() => {
                    resetModalAndClose();
                    // Optionally redirect to payment links list
                    // history.push("/payment-links");
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    background: "transparent",
                    color: "var(--text-color, #fff)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: "10px",
                    fontSize: "13px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.05)";
                    e.currentTarget.style.borderColor =
                      "rgba(255,255,255,0.35)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
                  }}
                >
                  Close
                </button>
              </>
            )}
          </div>
        </div>
      )}
      {/* window.location.origin == DEMOBROKER */}
      {window.location.origin == DEMOBROKER ? (
        <div
          className={`d-flex align-items-end flex-column bd-highlight mb-3 footer-data ${
            !isFooterExpanded ? "footer-data-collapsed" : ""
          }`}
          style={{ zIndex: "9" }}
        >
          <div
            className="mt-auto p-2 bd-highlight footer-data-text"
            style={{ cursor: "pointer" }}
          >
            <div
              className="d-flex align-items-center"
              onClick={() => setIsFooterExpanded(!isFooterExpanded)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={logo}
                alt=""
                style={{
                  marginRight: isFooterExpanded ? 3 : 0,
                  height: "30px",
                }}
              />
              {isFooterExpanded && (
                <span>Powered by PayBito infrastructure</span>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <ProductTour
        isOpen={showTour}
        onClose={() => setShowTour(false)}
        history={history}
      />
      <Loader show={!isColorsLoaded} />
    </Fragment>
  );
};

export default Header;
